import { queryClient } from '@/queryclient';

export const DEFAULT_GOAL = `Hunt for undiscovered 0-day vulnerabilities not yet assigned a CVE. Target CVSS 10.0 severity: network-exploitable, requires no authentication, no user interaction, and achieves remote code execution or complete system compromise. Prioritize weaponizable flaws with high EPSS potential—memory corruption, command injection, deserialization, and authentication bypasses that grant immediate attacker control. Ignore low-impact findings. Focus exclusively on critical, exploit-ready vulnerabilities.`;

export const PIPELINES = ['premium', 'medium', 'basic'] as const;
export type Pipeline = (typeof PIPELINES)[number];

export function invalidateOsintQueries() {
  queryClient.invalidateQueries({
    predicate: query => {
      const queryKey = query.queryKey as string[];
      return (
        (queryKey[0] === 'MY' && queryKey.includes('osint')) ||
        queryKey[0] === 'OSINT'
      );
    },
    refetchType: 'active',
  });
}
